import { logout } from "../services/UserService";

export function cacheUser(user) {
    localStorage.setItem('user', user);
};

export function uncacheUser() {
    localStorage.removeItem('user');
};

export function userCache() {
    return localStorage.getItem('user');
};
export function userCacheId() {
    const user = JSON.parse(userCache());
    return user? user.id : null;
};

export function userCacheName() {
    const user = JSON.parse(userCache());
    return user? user.firstName : null;
};

export function cacheFavorites(favorites) {
    localStorage.setItem('favorites', JSON.stringify(favorites));
};
export function uncacheFavorites() {
    localStorage.removeItem('favorites');
};
export function favoritesCache() {
    return localStorage.getItem('favorites');
};
export function refreshUserCacheToken(accessToken, refreshToken) {
    const user = JSON.parse(userCache());
    user.accessToken = accessToken;
    user.refreshToken = refreshToken;
    cacheUser(JSON.stringify(user));
};

export async function asyncUserCache() {
    return JSON.parse(localStorage.getItem('user'));
};

export async function asyncUserToken() {
    const user = await asyncUserCache();
    return user? {accessToken: user.accessToken, refreshToken: user.refreshToken} : null;
};

export const executelogout = (userId) => {
    logout(userId);
    uncacheUser();
    uncacheFavorites();
    window.location.reload(false);
  };